import { type FC } from 'react';

import { useTimerToEnd } from '@/common/hooks/timer-to-end';
import { timeStringFormat } from '@/common/lib/timer';

interface TimerProps {
  screen: 'default' | 'upgrade' | 'rewards';
  expiredAt?: string;
}

const Timer: FC<TimerProps> = ({ screen, expiredAt }) => {
  const secondsToEnd = useTimerToEnd(expiredAt);

  const time = timeStringFormat((secondsToEnd || 0) * 1000);

  return (
    screen === 'default' &&
    expiredAt && (
      <div
        className="absolute top-0 left-0 h-7 min-w-[5.125rem] px-2 rounded-br-2xl flex items-center justify-center text-golden-brown text-sm font-semibold"
        style={{
          background:
            'radial-gradient(79.34% 141.42% at 0% 0%, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.00) 100%), linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(255, 255, 255, 0.00) 100%), #FFA00F',
          backgroundBlendMode: 'overlay, overlay, normal',
        }}
      >
        {time}
      </div>
    )
  );
};

export { Timer };
